import {IconPopupItem} from "./IconPopupItem";
import {Button, Grid, TextField} from "@mui/material";
import React, {useEffect} from "react";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../misc/SyncedRef";
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ChatIcon from '@mui/icons-material/Chat';

export function NotesPopup(props: {
    value: string;
    onChange(value: string): Promise<any>;
}) {
    const [open, setOpen] = React.useState(false);

    return (
        <div style={{paddingLeft: 8}}>
            <IconPopupItem
                icon={
                    !!props.value ?
                        <ChatIcon color="primary" /> :
                        <ChatBubbleOutlineIcon />
                }
                open={open}
                onOpen={(tf) => setOpen(tf)}
            >
                <div style={{padding: 8}}>
                    <NotesInner value={props.value} onChange={props.onChange} onCancel={() => setOpen(false)} />
                </div>
            </IconPopupItem>
        </div>
    );
}

export function NotesInner(props: {
    value: string;
    onChange(value: string): Promise<any>;
    onCancel?(): void;
}) {
    const [value, setValue] = React.useState(props.value);
    useEffect(() => {
        setValue(props.value)
    }, [props.value]);

    const onChangeRef = useSyncedRef(props.onChange);
    const action = useAsyncAction(async (value: string) => {
        await onChangeRef.current(value);
    }, [])

    return <>
        <TextField label="Driver Note"
                   fullWidth
                   multiline
                   minRows={4}
                   value={value}
                   onChange={e => setValue(e.target.value)}
        />
        <div style={{height: 8}} />
        <Grid container spacing={1} justifyContent="flex-end">
            {action.LoadingElement}
            {props.onCancel && <Grid item><Button size="small" onClick={props.onCancel}>Cancel</Button></Grid>}
            {(props.onCancel || props.value !== value) && <Grid item><Button size="small" variant="contained" onClick={() => {
                action.callback(value);
            }}>Save</Button></Grid>}
        </Grid>
    </>
}